import {
  externalLinksSchema,
  externalLinksArraySchema,
} from "./externalLinks.schema";

export const getSpeakersSchema = {
  querystring: {
    type: "object",
    properties: {
      page: { type: "number" },
      limit: { type: "number" },
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const createSpeakerSchema = {
  body: {
    type: "object",
    properties: {
      firstName: { type: "string" },
      lastName: { type: "string" },
      occupation: { type: "string" },
      biography: { type: "string" },
      picture: { type: "string" },
      eventId: { type: "number" },
      userId: { type: "number" },
      links: { type: "array", items: externalLinksSchema },
    },
    required: ["firstName", "lastName", "eventId"],
  },
};

export const web_createSpeakerSchema = {
  type: "object",
  properties: {
    firstName: { type: "string", minLength: 1 },
    lastName: { type: "string", minLength: 1 },
    occupation: { type: ["string", "null"] },
    biography: { type: ["string", "null"] },
    picture: { type: "string" },
    eventId: { type: "number" },
    links: {
      type: "array",
      items: externalLinksArraySchema,
    },
  },
  required: ["firstName", "lastName", "eventId"],
};

export const web_patchSpeakerSchema = {
  type: "object",
  properties: {
    firstName: { type: "string", minLength: 1 },
    lastName: { type: "string", minLength: 1 },
    occupation: { type: ["string", "null"] },
    biography: { type: ["string", "null"] },
    picture: { type: ["string", "null"] },
    userId: { type: ["number", "null"] },
    links: { type: "array", items: externalLinksArraySchema },
  },
  required: ["userId", "firstName", "lastName"],
};

export const web_speakerFormSchema = {
  type: "object",
  properties: {
    firstName: { type: "string", minLength: 1 },
    lastName: { type: "string", minLength: 1 },
    occupation: { type: ["string", "null"] },
    biography: { type: ["string", "null"] },
    picture: { type: ["string", "null"] },
    userId: { type: ["number", "null"] },
    eventId: { type: "number" },
    links: {
      type: "array",
      items: externalLinksArraySchema,
    },
    logo: { type: ["string", "null"] },
    repIds: { type: "array", items: { type: "string" } },
  },
  required: ["firstName", "lastName"],
  additionalProperties: false,
};

export const createSpeakersImportSchema = {
  body: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      file: {
        type: "object",
        properties: {
          data: { type: "string" },
          name: { type: "string" },
          type: {
            type: "string",
            enum: [
              "text/csv",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/vnd.ms-excel",
            ],
          },
        },
        required: ["data", "name", "type"],
      },
    },
    required: ["eventId", "file"],
  },
};

export const patchSpeakerSchema = {
  body: {
    type: "object",
    properties: {
      firstName: { type: "string" },
      lastName: { type: "string" },
      occupation: { type: "string" },
      biography: { type: "string" },
      picture: { type: "string" },
      userId: { type: "number" },
      links: { type: "array", items: externalLinksSchema },
    },
    additionalProperties: false,
  },
};

export const deleteSpeakerSchema = {
  body: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};
